export default __webpack_public_path__ + "static/media/template1.8543de12.png";